import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios';
import Loader from '../components/Loader';


const Nudges = () => {
    const [apidata, setApiData] = useState([])
    const [loading, setLoading] = useState(true)


    useEffect(() => {
        getApidata()
    }, [])

    useEffect(() => {
        console.log(apidata)
    }, [apidata])

    const getApidata = async () => {
        axios.get(`/pages/343?acf_format=standard`)
            // axios.get(`/programs/74`)
            .then((response) => {
                console.log(response.data)
                setApiData(response.data.acf.nudges_nudges)
                // setProgramdetails(response.data[0])
                // setLink(response.data[0].acf.buy_link_program)
                setLoading(false)
            })
    }

    return (
        <>
            {
                loading ? <Loader /> :
                    <>
                        <div className="bottom15px">
                            <p className='brand-text gradient-heading'>
                                Evaluate & Reframe your Choices
                            </p>
                        </div>
                        {
                            apidata.map(eachnudge => (
                                <div className='min-h-[140px]'>
                                    <div className='flex flex-row gap-4 items-center'>
                                        <div className='min-w-[100px] max-w-[100px]'>
                                            <img src={eachnudge.nudge_icon_nudges} width={200} />
                                        </div>
                                        <div className='flex flex-col'>
                                            <p className='gradient-small text-left bottom15px'>{eachnudge.nudge_text_nudges}</p>
                                            <p className='txt-small text-left'>{eachnudge.nudge_subtext_nudges}</p>
                                        </div>
                                    </div>
                                </div>
                            )
                            )
                        }
                    </>
            }
        </>
    )
}

export default Nudges